/* @flow */
export default ngModule => {
    ngModule.factory('CorporateService', function (AonApi) {

        class CorporateService {

            /**
             * After the application has been submitted, operators can save checklist
             * responses which are stored in the applicant's json data.
             * @param reference: reference number used to identify a FundApplication on the backend
             * @param applicationData: updated application data to save
             * @return {*} Promise
             */
            saveCorporateScriptResponse(reference, script_responses) {
                return AonApi.post('corporate-script-response', { reference, script_responses });
            }
        }

        return new CorporateService();
    });
}


// WEBPACK FOOTER //
// ./src/services/corporate-service.js